import { Editor, Range, Transforms } from 'slate';
import type AhaEditor from '../../AhaEditor';
import TableUtils from './TableUtils';

const handleInsertableCharacterKey = (
  ahaEditor: AhaEditor,
  event: KeyboardEvent
) => {
  if (event.metaKey || event.ctrlKey) return false;

  const { editor, controller } = ahaEditor;
  if (!editor.selection || Range.isCollapsed(editor.selection)) {
    return false;
  }

  const { tableSelection } = controller.state.pluginState;
  if (!tableSelection) return false;

  if (!tableSelection.multipleCellsSelected) return false;
  if (!tableSelection.focusCellPath) return false;

  TableUtils.clearCellContents(editor, tableSelection.focusCellPath);
  const pointToSelect = Editor.point(editor, tableSelection.focusCellPath);
  tableSelection.reset();
  Transforms.select(editor, pointToSelect);

  return false;
};

export default handleInsertableCharacterKey;
